import { LicenseType } from "@shared-features/enums/license-type.enum";

export class BulkDriver {
  firstName: string;
  lastName: string;
  fleetId: number;
  iqamaId: number;
  nonResidentId: number;
  mobileNumber: string;
  nationality: string;
  truckPlateNumber: string;
  licenseType: LicenseType;
  licenseExpiry: Date|string;
  iqamaIdExpiry: Date|string;
  birthDate: Date|string;
  owner: string;
  profilePictureId: number;
  isLead: boolean;
}

export class ValidatedBulkDriver extends BulkDriver{
  errors?: {property: string, messages: string[]}[];

  get exist(): boolean {
    /**
     * @todo: what makes the driver is exist?
     */
    return !!this.errors && !!this.errors.find(err => err.messages.join(', ').includes('already exists'));
  }

  get duplicated(): boolean {
    return !!this.errors && !!this.errors.find(err => err.messages.join(', ').includes('duplicated'));
  }

  get failed(): boolean {
    return !!this.errors && !!this.errors.length;
  }
}

